import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { KYDVenue } from "@common/interfaces/KYDEvent";
import ShowIfHasPermission from "./ShowIfHasPermission";
import { EditModalType } from "src/utils";
import { KYDAdminEventDetailSectionPermissions } from "@common/interfaces/KYDEvent";

const VenueDisplayHeader = ({
  venue,
  permissions,
  setModalType,
}: {
  venue?: Partial<KYDVenue>;
  permissions: KYDAdminEventDetailSectionPermissions;
  setModalType: (modalType: EditModalType) => void;
}) => {
  if (!venue) return null;

  return (
    <Box>
      <HStack>
        <Text fontSize={"sm"} fontWeight={"medium"}>
          {venue.name}
        </Text>
        <ShowIfHasPermission permissions={permissions} checkFor="write">
          <Text
            textDecor={"underline"}
            onClick={() => setModalType(EditModalType.VENUE)}
            cursor={"pointer"}
            fontSize={"xs"}
            color="#1D74FF"
          >
            Change Venue
          </Text>
        </ShowIfHasPermission>
      </HStack>

      <Text fontSize={"xs"} fontWeight={"medium"} color="gray.500">
        <a target="_blank" rel="noreferrer" href={venue.link}>
          {venue.address}
        </a>
      </Text>
      {venue.location?.Country === "USA" && !venue.stripe_location_id ? (
        <Text fontSize={"xs"} color="red.400" fontWeight={"medium"}>
          This venue is missing a tax location ID.
          <br />
          Please contact support.
        </Text>
      ) : null}
    </Box>
  );
};

export default VenueDisplayHeader;
